import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';

const List = ({ t, reportOptions, title, requireAddress, requirePostcode, requireChildSchool, ...rest }) => {
	const columns = [
		{
			header: t('ReportChildren_Child'),
			accessor: 'child',
			cell: (child, row) => (<Link to={`/parents/${row.parentId}/children/${row.childId}`} > {child} ({ui.formatShortDate(row.dateOfBirth)})</Link>),
			sortable: true
		},
		{
			header: t('ReportChildren_Parent'),
			accessor: 'parent',
			cell: (parent, row) => (<Link to={`/parents/${row.parentId}`} > {parent}</Link>),
			sortable: true
		}
	];
	if (!reportOptions.hideParentDetails) {
		if (requireAddress) {
			columns.push({
				header: t('Parent_Address'),
				accessor: 'address',
				sortable: true
			});
		}
		if (requirePostcode) {
			columns.push({
				header: t('Parent_PostCode'),
				accessor: 'postcode',
				sortable: true
			});
		}
		columns.push({
			header: t('ReportChildren_PhoneNumber'),
			accessor: 'phoneNumber',
			sortable: true
		});
		columns.push({
			header: t('ReportChildren_Email'),
			accessor: 'email',
			sortable: true
		});
		if (requireChildSchool) {
			columns.push({
				header: t('ReportChildren_School'),
				accessor: 'schoolName',
				sortable: true
			});
		}
		columns.push({
			header: t('ReportChildren_Created'),
			accessor: 'created',
			sortable: true,
			cell: created => ui.formatDateTime(created)
		});
	}
	if (!reportOptions.requiredCenter) {
		columns.push({
			header: reportOptions.centerLabel,
			accessor: 'center',
			sortable: true
		});
	}
	if (reportOptions.showTotalAmount) {
		columns.push({
			header: t('ReportChildren_TotalAmount'),
			accessor: 'totalAmount',
			cell: (totalAmount) => ui.formatAmount(totalAmount),
			sortable: true
		});
	}

	if (reportOptions.showLessonInfo) {
		columns.push({
			header: t('ReportChildren_Grade'),
			accessor: 'gradeName',
			sortable: true
		});
		columns.push({
			header: t('ReportChildren_WeekDay'),
			accessor: 'weekDay',
			cell: weekDay => weekDay && t(ui.days[weekDay]),
			sortable: true
		});
		columns.push({
			header: t('ReportChildren_StartTime'),
			accessor: 'startTime',
			cell: startTime => ui.formatTime(startTime),
			sortable: true
		});
	}
	if (reportOptions.showGrage) {
		columns.push({
			header: t('ReportChildren_Grade'),
			accessor: 'gradeName',
			sortable: true
		});
	}
	if (reportOptions.showIsAttended) {
		columns.push({
			header: t('ReportChildren_LessonDate'),
			accessor: 'lessonDate',
			sortable: true,
			cell: (lessonDate) => (ui.formatDate(lessonDate)),
		});
		columns.push({
			header: t('ReportChildren_IsAttended'),
			accessor: 'isAttended',
			sortable: true,
			cell: (isAttended) => (ui.formatBoolean(isAttended))
		});
	}
	if (reportOptions.showEnrolled) {
		columns.push({
			header: t('ReportChildren_Enrolled'),
			accessor: 'enrolled',
			sortable: false,
			cell: (enrolled) => ui.formatBoolean(enrolled)
		});
	}
	if (reportOptions.showLessonNumber) {
		columns.push({
			header: t('ReportChildren_NumberNormalLessons'),
			accessor: 'numberNormalLessons',
			sortable: true
		});
		columns.push({
			header: t('ReportChildren_NumberAttendedNormalLessons'),
			accessor: 'numberAttendedNormalLessons',
			sortable: true
		});
	}

	return (
		<Panel>
			{title && <Panel.Heading> {title} </Panel.Heading>}
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);